import React, { useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Login.css'
import googleIcon from '../../../../images/google.svg';
import { useAuthState, useSendPasswordResetEmail, useSignInWithEmailAndPassword } from 'react-firebase-hooks/auth';
import auth from '../../../../firebase.init';
import GoogleLogin from '../Signup/GoogleLogin';
import Loading from '../../../Loading/Loading';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {

  let navigate = useNavigate();
  let location = useLocation();
  
  const [userLogin, loadingUser] = useAuthState(auth);
  let from = location.state?.from?.pathname || "/";
  const [
    signInWithEmailAndPassword,
    user,
    loading,
    error,
  ] = useSignInWithEmailAndPassword(auth);
  const emailRef = useRef('')
  const loginForm = event => {
    const email = event.target.email.value;
    const password = event.target.password.value;
    event.preventDefault();
    signInWithEmailAndPassword(email, password);
  }

  // Forget Password
  const [sendPasswordResetEmail, sending, error2] = useSendPasswordResetEmail(auth);

  const SendPasswordReset =async () => {
    const email = emailRef.current.value;
   if(email) {
    await sendPasswordResetEmail(email);
    console.log(error2)
    if(!error2) {
      toast('Reset Password email sent.');
    }
   } else {
    toast('Please provide a email');
   }
  }

  if (loadingUser) {
    return (
      <div>
       <Loading/>
      </div>
    );
  }

  if(userLogin){
    navigate(from, { replace: true });
  };

  return (
    <div className='login_page'>

      <div className="login_form">
        <h3>Login</h3>
        <form onSubmit={loginForm}>
          <label>Email</label><br />
          <input ref={emailRef} name='email' required type="email" /><br />
          <label>Password</label><br />
          <input name='password' required type="password" /><br />
          <span className='error_message'>{error?.message}</span><br />
          <button className='login_btn'>{
            loading ? 'Loading...' : 'Login'
          }</button><br />
          <span>New to Ema-john? <Link to='/signup'>Create New Account</Link></span>
        </form>
        <ToastContainer />
        <button className='btn-warning btn-sm mb-3 mt-3' onClick={SendPasswordReset}>Reset password</button><br />
         <GoogleLogin/>
      </div>
      
    </div>
  );
};

export default Login;